import React, { useState, useEffect } from 'react'
import {Menu} from 'antd'
const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup;
import './MenuLayout.less'

function MenuLayout(props) {
    const [currentId, setCurrentId] = useState("1")

    useEffect(() => {
        updateSelectMenu()
    }, [props.history.location.pathname])

    function findTabByPathName(){
        let currentPath = props.history.location.pathname.split("/")[1]
        let tab = props.tabList.find(item => {
            return item.name === currentPath.toString()
        })
        return tab
    }

    function findTabChildByPathName(items){
        let pathArr = props.history.location.pathname.split("/")
        if(!pathArr || pathArr.length<3){
            return null
        }else{
            let currentPath = pathArr[2]
            let tab = items.find(item => {
                return item.name === currentPath.toString()
            })
            return tab
        }
    }

    function updateSelectMenu(){
        let temp = findTabByPathName()
        if(!temp){return}
        if(temp.tItems&&temp.tItems.length>0){
            let child = findTabChildByPathName(temp.tItems)
            if(temp.tRoute && !child){
                setCurrentId(`${temp.tItems[0].id.toString()}:${temp.id.toString()}`)
            }else{
                setCurrentId(`${child.id.toString()}:${temp.id.toString()}`)
            }
        }else{
            setCurrentId(temp.id.toString())
        }
        window.scrollTo(0, 0)
    }

    function createMenuItem (data) {
          return  data.map( item =>{
            if(item.tItems){
                return  <SubMenu  title={item.title} key={item.id.toString()} onTitleClick={handleClick}>
                    <MenuItemGroup>
                    {createMenuItem(item.tItems)}
                    </MenuItemGroup>
                </SubMenu>
            }else {
                return <Menu.Item key={ item.pId? `${item.id.toString()}:${item.pId.toString()}`:`${item.id.toString()}`} >
                    {item.title}
                </Menu.Item>
            }
        })
    }

    function findClickTab(array){
        for(let i =0; i< props.tabList.length;i++){
            let temp = props.tabList[i]
            if(temp.tItems&&array.length>1){
                for(let j=0;j<temp.tItems.length;j++){
                    if(temp.tItems[j].id===parseInt(array[0]) &&
                        temp.tItems[j].pId === parseInt(array[1])){
                        return temp.tItems[j]
                    }
                }
            }else if(temp.id === parseInt(array[0])) {
                return temp
            }
        }
    }

    function handleClick(e){
        let array = e.key.split(':')
        setCurrentId(e.key)
        let temp = findClickTab(array)
        props.history.push(temp.tRoute)
    }

    return <Menu className="menu_layout"
                 mode="horizontal"
                 selectedKeys={[currentId]}
                 onClick={handleClick}
                 >
        {createMenuItem(props.tabList)}
    </Menu>
}

export default MenuLayout
